// extracted by mini-css-extract-plugin
export default {"error":"Error_error__R9m+S","debugDetails":"Error_debugDetails__16pbr"};